<template >
  <header class="header">
    <div class="container">
      <router-link to="/" tag="div" class="logo">
        <img :src="require(`@/assets/img/logo.svg`)" alt="logo_image" />
        <p>bridgeport United fc</p>
      </router-link>
      <nav :class="{'menu-open' : isClose}">
        <ul class="menu">
          <li v-for="link in links" :key="link.title" :class="link.class">
            <router-link :to="link.url" v-if="link.url">{{link.title}}</router-link>
            <a v-else>
              {{link.title}}
              <svg
                width="9"
                height="6"
                viewBox="0 0 9 6"
                fill="none"
                v-if="link.class == 'sub-menu'"
              >
                <path
                  d="M4.83257 5.61961L8.6199 1.83222C8.70756 1.74462 8.75586 1.62768 8.75586 1.503C8.75586 1.37831 8.70756 1.26138 8.6199 1.17378L8.34105 0.894864C8.15935 0.713371 7.86404 0.713371 7.68261 0.894864L4.50224 4.07523L1.31834 0.891335C1.23068 0.803737 1.11381 0.755371 0.989193 0.755371C0.864439 0.755371 0.747572 0.803737 0.659836 0.891335L0.381059 1.17025C0.293391 1.25792 0.245095 1.37478 0.245095 1.49947C0.245095 1.62415 0.293391 1.74109 0.381059 1.82869L4.17185 5.61961C4.25979 5.70742 4.37721 5.75565 4.50203 5.75537C4.62734 5.75565 4.74469 5.70742 4.83257 5.61961Z"
                  fill="black"
                />
              </svg>
            </a>

            <ul v-if="link.class == 'sub-menu'">
              <li v-for="item in link.subMenu" :key="item.title">
                <router-link :to="item.url">{{item.title}}</router-link>
              </li>
            </ul>
          </li>
        </ul>
        <a
          target="_blank"
          href="https://macronstorect.tuosystems.com/stores/bptunited"
          class="btn btn-8"
        >
          <span class="text">Shop</span>
        </a>
      </nav>
      <div class="menu-btn" @click="menuOpen" :class="{active: isClose}">
        <i v-for="n in 3" :key="n"></i>
      </div>
    </div>
  </header>
</template>
<script>
export default {
  data() {
    return {
      isClose: false,
      links: [
        {
          title: "Season",
          class: "sub-menu",
          subMenu: [
            { title: "Standings", url: "/standings" },
            { title: "Schedule", url: "/schedule" },
            { title: "News", url: "/news" },
          ],
        },
        {
          title: "TEAM",
          class: "sub-menu",
          subMenu: [
            { title: "Players", url: "/players" },
            { title: "Staff", url: "/staff" },
          ],
        },
        { title: "About", url: "/about" },
        { title: "SPONSORS", url: "/sponsors" },
      ],
    };
  },
  watch: {
    $route() {
      this.isClose = false;
      document.querySelector(".prevent-overlay").classList.remove("show");
    },
  },
  methods: {
    menuOpen() {
      this.isClose = !this.isClose;
      document.querySelector(".prevent-overlay").classList.toggle("show");
    },
  },
};
</script>
<style lang="scss" scoped>
.menu-btn {
  display: none;
  width: 2rem;
  height: 1.4rem;
  position: relative;
  cursor: pointer;
  @media only screen and (max-width: 768px) {
    display: block;
  }
  i {
    background-color: #15224e;
    border-radius: 2px;
    content: "";
    display: block;
    width: 100%;
    height: 2px;
  }
  i:nth-child(1) {
    -webkit-animation: outT 0.8s backwards;
    animation: outT 0.8s backwards;
    -webkit-animation-direction: reverse;
    animation-direction: reverse;
  }
  i:nth-child(2) {
    margin: 4px 0;
    -webkit-animation: outM 0.8s backwards;
    animation: outM 0.8s backwards;
    -webkit-animation-direction: reverse;
    animation-direction: reverse;
  }
  i:nth-child(3) {
    -webkit-animation: outBtm 0.8s backwards;
    animation: outBtm 0.8s backwards;
    -webkit-animation-direction: reverse;
    animation-direction: reverse;
  }
  &.active {
    i:nth-child(1) {
      -webkit-animation: inT 0.8s forwards;
      animation: inT 0.8s forwards;
    }
    i:nth-child(2) {
      -webkit-animation: inM 0.8s forwards;
      animation: inM 0.8s forwards;
    }
    i:nth-child(3) {
      -webkit-animation: inBtm 0.8s forwards;
      animation: inBtm 0.8s forwards;
    }
  }
}
header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 8rem;
  border: 1px solid #f2f2f2;
  z-index: 100;
  background: #f9faff;
  .container {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    height: 100%;
    @media only screen and (max-width: 768px) {
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
    }
  }
}
.logo {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 1.2rem 0 1.2rem 2rem;
  border-left: 1px solid #f2f2f2;
  border-right: 1px solid #f2f2f2;
  width: calc(100% / 3);
  cursor: pointer;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  @media only screen and (max-width: 992px) {
    padding: 1.2rem 1.5rem;
  }
  @media only screen and (max-width: 768px) {
    width: auto;
    border: none;
    padding: 1.2rem 0;
  }
  img {
    width: 5.5rem;
    height: 5.5rem;
    @media only screen and (max-width: 992px) {
      width: 4.5rem;
      height: 4.5rem;
    }
  }
  p {
    font-size: 2.1rem;
    font-weight: 700;
    text-transform: uppercase;
    margin-left: 1.8rem;
    @media only screen and (max-width: 1199px) {
      font-size: 1.9rem;
    }
    @media only screen and (max-width: 992px) {
      font-size: 1.3rem;
      margin-left: 1.2rem;
    }
    @media only screen and (max-width: 768px) {
      font-size: 1.6rem;
    }
    @media only screen and (max-width: 599px) {
      font-size: 1.4rem;
    }
  }
}
nav {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: flex-end;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 100%;
  @media only screen and (max-width: 768px) {
    position: fixed;
    height: calc(100vh - 7rem);
    width: 100%;
    min-width: 20rem;
    background: #f9faff;
    top: 7rem;
    right: -100%;
    z-index: 99;
    flex-direction: column;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    transition: all 0.5s ease-out;
    overflow-y: auto;
  }
  &.menu-open {
    right: 0;
  }
}
.menu {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: flex-end;
  margin-right: 2rem;
  height: 100%;
  @media only screen and (max-width: 768px) {
    width: 100%;
    margin-right: 0;
    height: auto;
    flex-direction: column;
  }
  & > li > a {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-weight: 500;
    font-size: 1.4rem;
    color: #151515;
    text-transform: uppercase;
    padding: 2rem;
    height: 100%;
    @media only screen and (max-width: 992px) {
      padding: 2rem 1rem;
    }
    @media only screen and (max-width: 768px) {
      padding: 1rem 2.5rem;
      height: auto;
    }
    svg {
      max-width: 0.9rem;
      margin-left: 8.5px;
      transition: all 0.3s ease-in-out;
      @media only screen and (max-width: 768px) {
        display: none;
      }
    }
  }
  & > li {
    position: relative;
    @media only screen and (max-width: 768px) {
      width: 100%;
    }
    & > a {
      position: relative;
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 0;
        transform: translateX(-50%);
        height: 3px;
        background: #fdc65a;
        border-top-right-radius: 2px;
        border-top-left-radius: 2px;
        transition: all 0.3s ease-in-out;
        @media only screen and (max-width: 768px) {
          display: none;
        }
      }
      &.router-link-active {
        &::after {
          width: 95%;
        }
        @media only screen and (max-width: 768px) {
          color: #fdc65a;
        }
      }
    }
    &:hover {
      a::after {
        width: 100%;
      }
      svg {
        transform: rotate(-180deg);
      }
    }
  }
  li.sub-menu {
    position: relative;
    ul {
      min-width: 100%;
      padding: 1rem 2rem;
      position: absolute;
      left: 50%;
      transform: translate(-50%, -30px);
      background: #fff;
      opacity: 0;
      visibility: hidden;
      z-index: -9;
      transition: all 0.3s ease-in-out;
      position: relative;
      @media only screen and (max-width: 768px) {
        visibility: visible;
        opacity: 1;
        position: relative;
        background: transparent;
        padding: 0;
        transform: translate(-50%, 0);
      }
      a {
        position: relative;
        display: block;
        white-space: nowrap;
        padding: 0.5rem 0;
        text-transform: capitalize;
        font-size: 1.4rem;
        color: #151515;
        font-weight: 500;
        @media only screen and (max-width: 768px) {
          padding: 0.5rem 2rem 0.5rem 3.5rem;
        }
        &:hover {
          color: #fdc65a;
        }
      }
      & > li {
        position: relative;
        @media only screen and (max-width: 768px) {
          width: 100%;
        }
        & > a {
          position: relative;
          &.router-link-active {
            color: #fdc65a;
          }
        }
        &:hover {
          a::after {
            width: 100%;
          }
          svg {
            transform: rotate(-180deg);
          }
        }
      }
    }
    &:hover {
      ul {
        opacity: 1;
        visibility: visible;
        z-index: 999;
        transform: translate(-50%, 0);
        &:after {
          width: 100%;
        }
      }
    }
  }
}
.btn {
  @media only screen and (max-width: 768px) {
    width: calc(100% - 4rem);
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
}

@-webkit-keyframes inM {
  50% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(45deg);
  }
}
@keyframes inM {
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(45deg);
  }
}

@-webkit-keyframes outM {
  50% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(45deg);
  }
}
@keyframes outM {
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(45deg);
  }
}

@-webkit-keyframes inT {
  0% {
    -webkit-transform: translateY(0px) rotate(0deg);
  }
  50% {
    -webkit-transform: translateY(6px) rotate(0deg);
  }
  100% {
    -webkit-transform: translateY(6px) rotate(135deg);
  }
}
@keyframes inT {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(6px) rotate(0deg);
  }
  100% {
    transform: translateY(6px) rotate(135deg);
  }
}

@-webkit-keyframes outT {
  0% {
    -webkit-transform: translateY(0px) rotate(0deg);
  }
  50% {
    -webkit-transform: translateY(6px) rotate(0deg);
  }
  100% {
    -webkit-transform: translateY(6px) rotate(135deg);
  }
}
@keyframes outT {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(6px) rotate(0deg);
  }
  100% {
    transform: translateY(6px) rotate(135deg);
  }
}

@-webkit-keyframes inBtm {
  0% {
    -webkit-transform: translateY(0px) rotate(0deg);
  }
  50% {
    -webkit-transform: translateY(-6px) rotate(0deg);
  }
  100% {
    -webkit-transform: translateY(-6px) rotate(135deg);
  }
}
@keyframes inBtm {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-6px) rotate(0deg);
  }
  100% {
    transform: translateY(-6px) rotate(135deg);
  }
}

@-webkit-keyframes outBtm {
  0% {
    -webkit-transform: translateY(0px) rotate(0deg);
  }
  50% {
    -webkit-transform: translateY(-6px) rotate(0deg);
  }
  100% {
    -webkit-transform: translateY(-6px) rotate(135deg);
  }
}
@keyframes outBtm {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-6px) rotate(0deg);
  }
  100% {
    transform: translateY(-6px) rotate(135deg);
  }
}
</style>